export enum Service {
  EMS = 'ems',
  HTTP = 'http',
  PREVIEW = 'preview',
  SNMP = 'snmp',
  SSH = 'ssh',
  TELNET = 'telnet',
}
